<template>
  <div class="view pa24">
    <el-page-header @back="goBack" content="" style="margin-bottom: 20px">
    </el-page-header>
    <div class="d-flex">
<!--      <el-row :gutter="24">-->
<!--        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">-->
<!--          <div class="d-flex align-items-center">-->
<!--            <el-input-->
<!--                v-model="query.handle"-->
<!--                class="mb10"-->
<!--                style="width: 240px"-->
<!--                placeholder="请输入标识码"-->
<!--                clearable-->
<!--            />-->
<!--            <el-button class="ml10 mb10" type="primary" @click="getCustomer">搜索</el-button>-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
    </div>
    <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border
        default-expand-all
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">

      <el-table-column
          prop="handle"
          align="center"
          label="标识码"
          v-if="!isWarehouse"
      />
      <el-table-column
          prop="codeName"
          align="center"
          label="名称"
          v-if="!isWarehouse"
      />
      <el-table-column
          prop="handle"
          align="center"
          label="二维码"
          v-if="!isWarehouse"
      >
        <template slot-scope="scope">
          <vue-qr :id="`codeImage${scope.row.handle}`" :size="50" :margin="0" :auto-color="true" :dot-scale="1" :text="`?h=${scope.row.handle}`"/>
        </template>
      </el-table-column>
<!--      <el-table-column-->
<!--          prop="num"-->
<!--          align="center"-->
<!--          label="数量"-->
<!--          v-if="!isWarehouse"-->
<!--      >-->
<!--        <template slot-scope="scope">-->
<!--          <el-button type="text" @click="codeDetail(scope.row)">{{scope.row.num}}</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column
          prop="className"
          align="center"
          label="产品类别"
      >
      </el-table-column>
      <el-table-column
          prop="partNumber"
          align="center"
          label="件号/存货编码"
      >
      </el-table-column>
      <el-table-column
          prop="num"
          align="center"
          label="数量"
      >
        <template slot-scope="scope">
          {{scope.row.num}}
          <span v-if="scope.row.length">*{{scope.row.length}}(m)</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="weight"
          align="center"
          label="重量(t)"
      >
      </el-table-column>
      <el-table-column
          prop="warehouseName"
          align="center"
          label="位置"
      >
      </el-table-column>
      <el-table-column
          prop="createBy"
          align="center"
          label="操作人"
      >
      </el-table-column>
      <el-table-column
          prop="createTime"
          align="center"
          label="操作时间"
      />
    </el-table>
    <div class="pageBox">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 15, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          class=""
          :total="total"
          :pager-count="5"
      />
    </div>
    <el-dialog title="二维码详情" :visible.sync="dialogTableVisible" modal-append-to-body append-to-body>
      <el-table :data="gridData">
        <el-table-column property="className" label="类别" align="center"></el-table-column>
        <el-table-column property="num" label="数量" align="center"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {selectCodeList,selectLogDetail} from  '@/api/storeLogBatch.js'
import VueQr from 'vue-qr'
export default {
  name:'codeDetail',
  components: {
    VueQr
  },
  props:{

  },
  data() {
    return {
      name:null,
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      batchId:'',
      query:{
        handle:''
      },
      dialogTableVisible:false,
      gridData:[],
      source:1,
      isWarehouse:false
    };
  },
  created() {
    this.batchId = this.$route.query.id
    this.source = this.$route.query.source
    this.isWarehouse = this.$route.query.isWarehouse
    this.getList()
  },
  methods: {
    getCustomer(){
      this.getList()
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    getList() {
      let params={
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        batchId:this.batchId
      }
      let  param= {...params,...this.query}
      selectCodeList(param).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },
    codeDetail(row){
      selectLogDetail({logId:row.id}).then(res=>{
        this.gridData = res.data
        this.dialogTableVisible = true
      })
    },
    goBack() {
      if (1 == this.source){
        this.$router.push({path:'/store/in'})
      }else if (2 == this.source){
        this.$router.push({path:'/store/out'})
      }else if (3 == this.source){
        this.$router.push({path:'/store/addLog'})
      }else if (4 == this.source){
        this.$router.push({path:'/store/circulation'})
      }else if (5 == this.source){
        this.$router.push({path:'/store/moving'})
      }
    }

  },

}
</script>
<style scoped lang="scss">

</style>
